import React from 'react';

import { LoginCard } from '@/components/organisms/Auth';
import { LoginLayout } from '@/components/templates/LoginLayout';
import { CmBox, CmHeading, CmText } from '@/components/uiParts';
import { routes } from '@/router';

import { BackButton } from './components/BackButton';
import { ForgotPasswordForm } from './components/ForgotPasswordForm';
import { usePasswordResetRequest } from './hooks/usePasswordResetRequest';

const ForgotPasswordPage = (): JSX.Element => {
  const passwordResetRequest = usePasswordResetRequest();

  return (
    <LoginLayout>
      <LoginCard>
        <CmHeading fontSize="2xl" mb={5} as="h1">
          {routes.ForgotPassword.title}
        </CmHeading>
        <CmBox mb={8}>
          <CmText>
            パスワード再設定用のURLを送信しますので、ご登録いただいているメールアドレスを入力してください。
          </CmText>
        </CmBox>

        <ForgotPasswordForm onSubmit={passwordResetRequest} />
        <BackButton textAlign="right">ログイン画面に戻る</BackButton>
      </LoginCard>
    </LoginLayout>
  );
};

export default ForgotPasswordPage;
